"use client";
import { useEffect } from "react";
import Hero from "@/components/Hero";
import UIBox from "@/components/UIBox";
import OurCompany from "@/components/OurCompany";
import WhyUs from "@/components/WhyUs";
import Services from "@/components/Services";
import Technologies from "@/components/Technologies";
import Testimonials from "@/components/Testimonials";
import ExperiencesCard from "@/components/ExperiencesCard";
import Reviews from "@/components/Reviews";
import NewsLatter from "@/components/NewsLatter";

const HomePage = () => {
  useEffect(() => {
    const reveal = () => {
      const reveals = document.querySelectorAll(".reveal");

      reveals.forEach((element) => {
        const windowHeight = window.innerHeight;
        const elementTop = element.getBoundingClientRect().top;
        const elementVisible = 10;

        const isVisible = elementTop < windowHeight - elementVisible;
        const hasActive = element.classList.contains("active");

        if (isVisible && !hasActive) {
          element.classList.add("active");
        } else if (!isVisible && hasActive) {
          element.classList.remove("active");
        }
      });
    };

    window.addEventListener("scroll", reveal);
    reveal();

    return () => window.removeEventListener("scroll", reveal);
  }, []);

  return (
    <>
      <Hero />
      <UIBox />
      <OurCompany />
      <WhyUs />
      <Services />
      {/* <Reviews /> */}
      <Technologies />
      <Testimonials />
      <ExperiencesCard />
    </>
  );
};

export default HomePage;
